module.exports = __webpack_public_path__ + "static/noisectrl-582f767c43ee77ac6bc49a1697befbad.png";